module.exports = __webpack_public_path__ + "static/img/2airbus1.ec46ab8a.png";